import SessionStorage from "../storage/SessionStorage";
import { messages } from "../localization/messages";

class WebSocketUtils {
  static _browserSupportsWebSockets() {
    return "WebSocket" in window;
  }

  static checkWebSocketSupport() {
    const supportChecked = SessionStorage.retreive("WebSocketSupportChecked");

    if (!supportChecked) {
      SessionStorage.persist("WebSocketSupportChecked", true);

      if (!WebSocketUtils._browserSupportsWebSockets()) {
        alert(messages.webSocketsUnsupportedMessage);
      }
    }
  }
}

export default WebSocketUtils;
